import { render, staticRenderFns } from "./control-consulta.vue?vue&type=template&id=03fefd8d&scoped=true"
import script from "./control-consulta.vue?vue&type=script&lang=js"
export * from "./control-consulta.vue?vue&type=script&lang=js"
import style0 from "./control-consulta.vue?vue&type=style&index=0&id=03fefd8d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03fefd8d",
  null
  
)

export default component.exports